module.exports = __webpack_public_path__ + "components/flag/static/square/il-a011582dd56552291b7fa3d0440115df.svg";